module.exports = __webpack_public_path__ + "static/media/steamcouture-2.538d427f.jpg";